import { ref, isRef, unref, watchEffect } from 'vue';
import axios from 'axios';

import type { Ref } from 'vue';
import type Inquiry from '@/javascripts/utils/inquiry';
import type { FormOption } from '@/javascripts/utils/inquiry_form_options';

/**
 * 市区町村に関するコンポーザブル関数
 * @param prefectureCd 都道府県コード
 */
export function useCity(prefectureCd: Inquiry['prefectureCd'] | Ref<Inquiry['prefectureCd']>) {
  /** 市区町村の選択肢リスト */
  const cities = ref<FormOption[]>([]);

  /** 市区町村リスト取得時エラー */
  const error = ref<string>();

  /**
   * 市区町村の選択肢リストを取得
   */
  async function fetchCities() {
    // 取得前に状態をリセット
    cities.value = [];
    error.value = null;

    // 都道府県コード未指定の場合は終了
    if(!unref(prefectureCd)) return;

    try {
      // 市区町村の選択肢リストAPIをコール
      const response = await axios.get<{ code: string, name: string }[]>(
        `/api/v1/code/setup_cities/${unref(prefectureCd)}`
      );

      // レスポンスの型(code, name)をFormOption型(cd, text)に変換してセット
      cities.value = response.data.map(formOption => ({ cd: formOption.code, text: formOption.name }));
    } catch (e) {
      console.error(e);
      error.value = '選択肢を取得できませんでした';
    }
  }

  if(isRef(prefectureCd)) {
    // 引数がリアクティブな値の場合、変更を監視
    watchEffect(fetchCities);
  }
  else {
    // 非リアクティブな値の場合は一度だけ取得
    fetchCities();
  }

  return {
    cities,
    error
  };
}

export default useCity;
